// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"2d824c6e","220":"5da87bec","302":"30d6a40c","560":"a180480f","882":"727e78c1"}[chunkId] + ".chunk.js";
};